import React from 'react';
import './index.scss';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import { defaultIsEmpty } from '../../../../../../../../utils/sectionState';
import Divergence from './children/Divergence';
import RatingsSpread from './children/RatingsSpread';

// These two sections should also hide when the scope says self-ratings
// aren't available, on top of the usual empty/error checks.
const isEmptyOrSelfUnavailable = (data) =>
  defaultIsEmpty(data) || (data && data.scope && data.scope.selfAvailable === false);

const SelfVsOtherPerception = (props) => {

  return (
    <>
      <AsyncSection api={props.fetchSelfVsOthersApi} isEmpty={isEmptyOrSelfUnavailable}>
        <Divergence />
      </AsyncSection>

      <AsyncSection api={props.fetchDistributionStripApi} isEmpty={isEmptyOrSelfUnavailable}>
        <RatingsSpread />
      </AsyncSection>
    </>
  );
};

export default SelfVsOtherPerception;
